import { createAsyncThunk } from "@reduxjs/toolkit";
import { type InvoicesClient } from "@fitness-app/data-models/entities/Product";
import { getError, getErrorMessage } from "@fitness-app/utils";

import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { PRODUCTS_SETTINGS_REDUCER_NAME } from "../types";

export type Payload = {
  url: string;
  client: InvoicesClient;
};

export const removeIntegrationWithInvoicesClient = createAsyncThunk<
  void,
  ActionParams<Payload>,
  AsyncThunkCreator<string>
>(
  `${PRODUCTS_SETTINGS_REDUCER_NAME}/removeIntegrationWithInvoicesClient`,
  async ({ onSuccess, onFailure, payload }, { rejectWithValue, extra: { integrationApi, analytics } }) => {
    try {
      await integrationApi.patch("/remove-invoice-client-integration", payload);

      analytics.track("remove_integration_with_invoices_client", {
        client: payload.client,
      });
      onSuccess?.();
    } catch (e) {
      onFailure?.(getError(e).status);

      return rejectWithValue(getErrorMessage(e));
    }
  },
);
